// extracted by mini-css-extract-plugin
export default {"table":"UITable_table__N+wbo"};